import { Injectable } from '@angular/core';
import { ApiCallContext, SafariObject } from '@safarilaw-webapp/shared/common-objects-models';
import { NoHiddenProps } from '@safarilaw-webapp/shared/crud';
import { DeliveryPortalRecipientModel } from '../../_rms-api-models.generated';
import { RmsDataAdapter } from '../../shared/rms-base-adapter';
import { DeliveryPortalRecipient } from '../models/app/delivery-portal-recipient';

@Injectable({
  providedIn: 'root'
})
export class DeliveryPortalRecipientAdapter extends RmsDataAdapter<DeliveryPortalRecipient> {
  /* NOTE: This object is weird. There is no GET endpoint for DeliveryPortalRecipient. It is only fetchable as part of
   * the DeliveryPortal model. This object cannot be fetched or updated on its own.
   * We're just putting this mapper here to distinguish between the API model and the app model. */
  fromGetModel(model: DeliveryPortalRecipientModel, context?: ApiCallContext): Required<NoHiddenProps<DeliveryPortalRecipient>> {
    return {
      id: this.helpers.fromApiId(SafariObject.NOID, context.__parentId),
      email: model.email,
      name: model.name,
      role: model.role,
      canBeRemoved: model.canBeRemoved,
      invitationDate: model.invitationDate,
      invitationFailed: model.invitationFailed,
      invitationErrorMessage: model.invitationErrorMessage
    };
  }
  toCreateModel(model: DeliveryPortalRecipient, context?: ApiCallContext<any>): DeliveryPortalRecipient {
    return {
      id: this.helpers.toApiId(model.id),
      name: model.name,
      email: model.email,
      role: model.role
    };
  }
  toDeleteModel(model: any) {
    return {
      email: model.email
    };
  }
}
